import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { ref, onValue, push, set, get, update } from "firebase/database";
import "../css/TeacherChat.css"; // 引入你的 CSS 文件

const TeacherChat = () => {
  const [searchParams] = useSearchParams();
  const questionId = searchParams.get("id");

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [image, setImage] = useState(null);
  const [videoRequested, setVideoRequested] = useState(false);

  const chatEndRef = useRef(null);
  const navigate = useNavigate();

  console.log("✅ Loaded questionId:", questionId);

  // 监听聊天内容
  useEffect(() => {
    if (!questionId) return;

    const chatRef = ref(db, `chats/${questionId}`);
    const unsubscribe = onValue(chatRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.values(data);
        setMessages(list);
      }
    });

    return () => unsubscribe();
  }, [questionId]);

  // 滚动到底部
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  // 监听视频请求
  useEffect(() => {
    if (!questionId) return;

    const qRef = ref(db, `waitingQuestions/${questionId}`);
    const unsubscribe = onValue(qRef, (snapshot) => {
      const data = snapshot.val();
      if (data?.videoRequested) {
        setVideoRequested(true);
      }
    });

    return () => unsubscribe();
  }, [questionId]);

  // 匹配学生
  const handleMatchStudent = async () => {
    if (!questionId) return;
    const qRef = ref(db, `waitingQuestions/${questionId}`);

    try {
      const snapshot = await get(qRef);
      if (snapshot.exists()) {
        const currentData = snapshot.val();
        await update(qRef, { ...currentData, matched: true });
        alert("✅ You have matched with the student!");
      } else {
        alert("⚠️ Question not found.");
      }
    } catch (err) {
      console.error("❌ Failed to match student:", err);
    }
  };

  // 图片选择
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result); // base64 string
      };
      reader.readAsDataURL(file);
    }
  };

  // 发送消息
  const handleSend = async () => {
    if (!input.trim() && !image) return;

    const newMessage = {
      sender: "teacher",
      text: input.trim(),
      image: image || null,
      timestamp: Date.now(),
    };

    const chatRef = ref(db, `chats/${questionId}`);
    const newMsgRef = push(chatRef);
    await set(newMsgRef, newMessage);

    setInput("");
    setImage(null);
  };

  // 接受视频通话并通知学生跳转
  const handleAcceptVideo = async () => {
    if (!questionId) return;
    const qRef = ref(db, `waitingQuestions/${questionId}`);

    try {
      await update(qRef, { startCall: true });
      navigate(`/videocall?id=${questionId}`);
    } catch (err) {
      console.error("❌ Failed to update startCall:", err);
    }
  };

  return (
    <div className="teacher-chat-container">
      <h2 className="teacher-chat-title">Teacher-Student Chat</h2>

      {questionId && (
        <div className="match-button-container">
          <button onClick={handleMatchStudent} className="match-button">
            ✅ Start Guiding Student
          </button>
        </div>
      )}

      <div className="chat-messages-container">
        {messages.map((msg, idx) => (
          <div
            key={idx}
            className={`message ${
              msg.sender === "teacher" ? "teacher-message" : "student-message"
            }`}
          >
            <div className="message-content">
              <strong className="sender-name">
                {msg.sender === "teacher"
                  ? "Teacher"
                  : msg.sender === "ai"
                  ? "AI"
                  : "Student"}
              </strong>
              <div className="message-body">
                {msg.image && (
                  <img
                    src={msg.image}
                    alt="uploaded"
                    className="message-image"
                  />
                )}
                <p className="message-text">{msg.text}</p>
              </div>
            </div>
          </div>
        ))}
        <div ref={chatEndRef} />
      </div>

      <div className="input-container">
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          className="file-input"
        />

        <textarea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          rows="2"
          className="message-input"
          placeholder="Type your message..."
        />

        <button onClick={handleSend} className="send-button">
          Send
        </button>
      </div>

      {videoRequested && (
        <div className="video-call-container">
          <button onClick={handleAcceptVideo} className="video-call-button">
            🎥 Accept Video Call
          </button>
        </div>
      )}
    </div>
  );
};

export default TeacherChat;
